// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LoginOutlinedSvg from "@fishx/icons-svg/es/asn/LoginOutlined";
import FishxIcon from '../components/FishxIcon';

var LoginOutlined = function LoginOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LoginOutlinedSvg
  }));
};

LoginOutlined.displayName = 'LoginOutlined';
export default React.forwardRef(LoginOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LoginOutlined.js
// module id = 3074
// module chunks = 0